/**
 * BagFast — Cart Drawer (Ajax)
 * Handles slide-out cart with free-shipping progress bar.
 */
(function () {
  'use strict';

  var SELECTORS = {
    drawer: '[data-cart-drawer]',
    overlay: '[data-cart-drawer-overlay]',
    openBtn: '[data-cart-drawer-open]',
    closeBtn: '[data-cart-drawer-close]',
    itemsContainer: '[data-cart-drawer-items]',
    itemCount: '[data-cart-count]',
    subtotal: '[data-cart-subtotal]',
    shippingBarFill: '[data-shipping-bar-fill]',
    shippingBarText: '[data-shipping-bar-text]',
    noteToggle: '[data-cart-note-toggle]',
    noteWrap: '[data-cart-note]',
    noteInput: '[data-cart-note-input]',
    emptyState: '[data-cart-empty]',
    filledState: '[data-cart-filled]',
    checkoutBtn: '[data-cart-checkout]',
  };

  /* -- Utility to format Shopify money (cents → display) -- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  /* -- State -- */
  var cart = null;
  var freeShippingThreshold = 0;

  function init() {
    /* Read threshold from data attr on drawer */
    var drawerEl = document.querySelector(SELECTORS.drawer);
    if (drawerEl) {
      freeShippingThreshold =
        parseInt(drawerEl.getAttribute('data-free-shipping'), 10) || 0;
    }

    bindEvents();
    refresh();
  }

  function bindEvents() {
    /* Open buttons */
    document.querySelectorAll(SELECTORS.openBtn).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    /* Close button */
    var closeBtn = document.querySelector(SELECTORS.closeBtn);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Overlay */
    var overlayEl = document.querySelector(SELECTORS.overlay);
    if (overlayEl) overlayEl.addEventListener('click', close);

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Note toggle */
    var noteToggle = document.querySelector(SELECTORS.noteToggle);
    if (noteToggle) {
      noteToggle.addEventListener('click', function () {
        var wrap = document.querySelector(SELECTORS.noteWrap);
        if (wrap) wrap.classList.toggle('is-open');
      });
    }

    /* Note update (debounce) */
    var noteInput = document.querySelector(SELECTORS.noteInput);
    var noteTimer;
    if (noteInput) {
      noteInput.addEventListener('input', function () {
        clearTimeout(noteTimer);
        var val = noteInput.value;
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: val }),
          });
        }, 600);
      });
    }

    /* Delegate qty / remove clicks */
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty-btn]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-line-key');
        var direction = qtyBtn.getAttribute('data-cart-qty-btn');
        var currentQty = parseInt(qtyBtn.getAttribute('data-current-qty'), 10);
        var newQty = direction === 'plus' ? currentQty + 1 : currentQty - 1;
        if (newQty < 1) newQty = 0; // 0 = remove
        updateItem(key, newQty);
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var lineKey = removeBtn.getAttribute('data-line-key');
        updateItem(lineKey, 0);
      }
    });
  }

  function open() {
    var drawerEl = document.querySelector(SELECTORS.drawer);
    var overlayEl = document.querySelector(SELECTORS.overlay);
    if (drawerEl) drawerEl.classList.add('is-open');
    if (overlayEl) overlayEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var drawerEl = document.querySelector(SELECTORS.drawer);
    var overlayEl = document.querySelector(SELECTORS.overlay);
    if (drawerEl) drawerEl.classList.remove('is-open');
    if (overlayEl) overlayEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refresh() {
    fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        cart = data;
        render();
      })
      .catch(function (err) {
        console.error('Cart fetch error:', err);
      });
  }

  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        cart = data;
        render();
      })
      .catch(function (err) {
        console.error('Cart update error:', err);
      });
  }

  function render() {
    if (!cart) return;

    /* Update count badges */
    document.querySelectorAll(SELECTORS.itemCount).forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    /* Subtotal */
    document.querySelectorAll(SELECTORS.subtotal).forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    /* Free-shipping bar */
    if (freeShippingThreshold > 0) {
      var thresholdCents = freeShippingThreshold * 100;
      var pct = Math.min((cart.total_price / thresholdCents) * 100, 100);
      var remaining = thresholdCents - cart.total_price;

      document.querySelectorAll(SELECTORS.shippingBarFill).forEach(function (el) {
        el.style.width = pct + '%';
      });
      document.querySelectorAll(SELECTORS.shippingBarText).forEach(function (el) {
        if (remaining <= 0) {
          el.textContent = 'You qualify for free shipping!';
        } else {
          el.textContent =
            'Add ' + formatMoney(remaining) + ' more for free shipping';
        }
      });
    }

    /* Show / hide empty state */
    var emptyEl = document.querySelector(SELECTORS.emptyState);
    var filledEl = document.querySelector(SELECTORS.filledState);
    var checkoutBtn = document.querySelector(SELECTORS.checkoutBtn);

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      if (filledEl) filledEl.style.display = 'none';
      if (checkoutBtn) checkoutBtn.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (filledEl) filledEl.style.display = '';
      if (checkoutBtn) checkoutBtn.style.display = '';
    }

    /* Render line items */
    var container = document.querySelector(SELECTORS.itemsContainer);
    if (!container) return;

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.\w+)(\?)/, '_180x$1$2')
        : '';

      html += '<div class="cart-item">';
      html += '  <div class="cart-item__image">';
      if (imgSrc) {
        html +=
          '    <img src="' +
          imgSrc +
          '" alt="' +
          item.product_title +
          '" loading="lazy">';
      }
      html += '  </div>';
      html += '  <div class="cart-item__details">';
      html +=
        '    <a href="' +
        item.url +
        '" class="cart-item__title">' +
        item.product_title +
        '</a>';
      if (item.variant_title) {
        html +=
          '    <span class="cart-item__variant">' +
          item.variant_title +
          '</span>';
      }
      html +=
        '    <span class="cart-item__price">' +
        formatMoney(item.final_line_price) +
        '</span>';
      html += '    <div class="cart-item__qty" data-qty-selector>';
      html +=
        '      <button class="cart-item__qty-btn" data-cart-qty-btn="minus" data-line-key="' +
        item.key +
        '" data-current-qty="' +
        item.quantity +
        '" aria-label="Decrease quantity">−</button>';
      html +=
        '      <span class="cart-item__qty-val" data-qty-value>' +
        item.quantity +
        '</span>';
      html +=
        '      <button class="cart-item__qty-btn" data-cart-qty-btn="plus" data-line-key="' +
        item.key +
        '" data-current-qty="' +
        item.quantity +
        '" aria-label="Increase quantity">+</button>';
      html += '    </div>';
      html +=
        '    <button class="cart-item__remove" data-cart-remove data-line-key="' +
        item.key +
        '">Remove</button>';
      html += '  </div>';
      html += '</div>';
    });

    container.innerHTML = html;
  }

  /* Public API */
  window.BagFastCart = {
    open: open,
    close: close,
    refresh: refresh,
  };

  /* Boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
